module.exports = __webpack_public_path__ + "media/images/menu/cygnus-1d85d21ffacd8c4dced4935fb1c5d58f.jpg";